import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {DropdownOption} from "../../../../../../models/dropdown-option.model";
import * as Validation from "../../../../../shared/constants/validation.constants";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../../../state/app.state";
import {Router} from "@angular/router";
import {CommonService} from "../../../../../shared/services/common.service";
import {FetchClinicStatusFilterListRequest, FetchOrgTypeFilterListRequest} from '../../../core/clients-list.actions';
import {clinicStatusListFilter, orgTypeListFilter} from '../../../core/clients-list.selectors';
import {Subject, takeUntil} from "rxjs";
import {ClientListService} from '../../../services/client-list.service';

@Component({
  selector: 'app-clinic-information-filter',
  templateUrl: './clinic-information-filter.component.html',
  styleUrls: ['./clinic-information-filter.component.css']
})
export class ClinicInformationFilterComponent implements OnInit, OnDestroy {

  private readonly OnDestroy: Subject<any> = new Subject<any>();
  loading: boolean = false;
  orgTypeList: DropdownOption[] = [];
  clinicStatusList: DropdownOption[] = [];
  errorMessages: any = {};
  validation = Validation;
  errorMessageMap = {
    'orgType': {},
    'status': {},
    'search': {}
  }

  form = new FormGroup({
    orgType: new FormControl(null),
    status: new FormControl(null),
    search: new FormControl(null),
  })

  constructor(
    private store: Store<fromRoot.State>,
    private router: Router,
    private commonService: CommonService,
    private clientListService: ClientListService,
  ) {
    this.store.dispatch(FetchOrgTypeFilterListRequest());
    this.store.dispatch(FetchClinicStatusFilterListRequest());
  }

  ngOnInit() {
    this.store.select(orgTypeListFilter)
      .pipe(takeUntil(this.OnDestroy))
      .subscribe((data) => {
        if (data.loading) {
          this.form.controls.orgType.disable()
        } else {
          this.form.controls.orgType.enable()
        }
        this.orgTypeList = data.list;
      });

    this.store.select(clinicStatusListFilter)
      .pipe(takeUntil(this.OnDestroy))
      .subscribe((data) => {
        if (data.loading) {
          this.form.controls.status.disable()
        } else {
          this.form.controls.status.enable()
        }
        this.clinicStatusList = data.list;
      });
  }

  apply() {
    // ERROR CHECK IN THE FORM//
    if (this.form.invalid) {
      this.checkForErrors();
      return;
    }
    if (!this.form.dirty) { // check is there any change
      return;
    }
    // changes just applied, so marking the form as un-dirty to avoid applying same filters again without changing anything
    this.form.markAsPristine();

    // EXTRACT VALUE FROM FORM//
    const filters = this.form.getRawValue();
    this.clientListService.onClinicFilterChange.next(filters)
  }

  checkForErrors(currentField ?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField))
    };
  }

  ngOnDestroy() {
    this.OnDestroy.next(null);
    this.OnDestroy.complete();
  }

}
